/* eslint-disable no-unused-expressions */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Cdtadvicepending from "./cdtadvicepending";
import Cdtadvicessent from "./cdtadvicessent";
import Cdtcreateadvice from "./cdtcreateadvice";
import CdtDeletedAdsvices from "./CdtDeletedAdsvices";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tab: {
    backgroundColor: "#2835d5",
    color: "#fff",
    borderRadius: "20px",
  },
  tabpanel: {
    color: "#000",
    marginTop: 30,
  },
}));

export default function Cdtcreateadvicetabs() {
  let tabPannelarr = [];

  // eslint-disable-next-line no-lone-blocks
  {
    localStorage.getItem("empRole") === "Research Team" ||
    localStorage.getItem("empRole") === "CEO" ||
    localStorage.getItem("empRole") === "CTO"
      ? (tabPannelarr = [
          {
            id: 0,
            showData: Cdtadvicepending,
            label: "Advices Pending",
          },
          {
            id: 1,
            showData: Cdtadvicessent,
            label: "Advices Sent",
          },
          {
            id: 2,
            showData: CdtDeletedAdsvices,
            label: "Deleted Advices",
          },
        ])
      : localStorage.getItem("empRole") === "Customer Delight Executive"
      ? (tabPannelarr = [
          {
            id: 0,
            showData: Cdtadvicepending,
            label: "Advices Pending",
          },
          {
            id: 1,
            showData: Cdtcreateadvice,
            label: "Create Advice",
          },
        ])
      : [];
  }
  // const tabPannelarr = [Customer Delight Executive
  //   {
  //     id: 0,
  //     showData: Cdtadvicepending,
  //     label: "Advices Pending",
  //   },
  //   {
  //     id: 1,
  //     showData: Cdtadvicessent,
  //     label: "Advices Sent",
  //   },
  //   {
  //     id: 2,
  //     showData: Cdtcreateadvice,
  //     label: "Create Advice",
  //   },
  // ];

  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    console.log(newValue, "newval");
    setValue(newValue);
  };

  const sendValue = () => {
    setValue(0);
  };
  console.log(value);
  // localStorage.getItem("empRole") === "Research Team";

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          style={{ color: "#000" }}
        >
          {/* <Tab
            label="Advices Pending"
            {...a11yProps(0)}
            className={value === 0 ? classes.tab : null}
          />
          <Tab
            label="Advices Sent"
            {...a11yProps(1)}
            className={value === 1 ? classes.tab : null}
          />
          <Tab
            label="Create Advice"
            {...a11yProps(2)}
            // className={value === 2 ? classes.tab : null}
          /> */}

          {tabPannelarr.map((item, index) => {
            if (
              localStorage.getItem("empRole") === "Research Team" ||
              localStorage.getItem("empRole") === "CEO" ||
              localStorage.getItem("empRole") === "CTO"
            ) {
              if (
                item.label === "Advices Pending" ||
                item.label === "Advices Sent" ||
                item.label === "Deleted Advices"
              ) {
                return (
                  <Tab
                    label={item.label}
                    {...a11yProps(item.id)}
                    className={value === item.id ? classes.tab : null}
                  />
                );
              }
            } else if (
              localStorage.getItem("empRole") === "Customer Delight Executive"
            ) {
              if (
                item.label === "Advices Pending" ||
                item.label === "Create Advice"
              ) {
                return (
                  <Tab
                    label={item.label}
                    {...a11yProps(item.id)}
                    className={value === item.id ? classes.tab : null}
                  />
                );
              }
            }
          })}
        </Tabs>
      </AppBar>
      {/* {localStorage.getItem("empRole") === "CTO" ? (
        <TabPanel value={value} index={0} className={classes.tabpanel}>
          <Cdtadvicepending />
        </TabPanel>
      ) : null}
      {localStorage.getItem("empRole") === "Reasearch Team" ? (
        <TabPanel value={value} index={1} className={classes.tabpanel}>
          <Cdtadvicessent />
        </TabPanel>
      ) : null}
      <TabPanel value={value} index={2} className={classes.tabpanel}>
        <Cdtcreateadvice sendValue={sendValue} />
      </TabPanel> */}

      {tabPannelarr.map((item, index) => {
        return (
          <TabPanel>
            {item.id === value ? <item.showData sendValue={sendValue} /> : ""}
          </TabPanel>
        );
      })}
    </div>
  );
}
